module.exports = __webpack_public_path__ + "static/project-main-arcurve-3a5d43cdfcd9becd15250fc9aad84549.jpg";